/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteStorageObject } from '../fn/storage-objects/delete-storage-object';
import { DeleteStorageObject$Params } from '../fn/storage-objects/delete-storage-object';
import { downloadFile } from '../fn/storage-objects/download-file';
import { DownloadFile$Params } from '../fn/storage-objects/download-file';
import { getStorageObject } from '../fn/storage-objects/get-storage-object';
import { GetStorageObject$Params } from '../fn/storage-objects/get-storage-object';
import { getStorageObjectUrl } from '../fn/storage-objects/get-storage-object-url';
import { GetStorageObjectUrl$Params } from '../fn/storage-objects/get-storage-object-url';
import { listStorageObjects } from '../fn/storage-objects/list-storage-objects';
import { ListStorageObjects$Params } from '../fn/storage-objects/list-storage-objects';
import { StorageObjectDto } from '../models/storage-object-dto';
import { StorageObjectDtoPage } from '../models/storage-object-dto-page';
import { StorageUrlDto } from '../models/storage-url-dto';
import { updateBulkStorageObject } from '../fn/storage-objects/update-bulk-storage-object';
import { UpdateBulkStorageObject$Params } from '../fn/storage-objects/update-bulk-storage-object';
import { updateStorageObject } from '../fn/storage-objects/update-storage-object';
import { UpdateStorageObject$Params } from '../fn/storage-objects/update-storage-object';
import { uploadFile } from '../fn/storage-objects/upload-file';
import { UploadFile$Params } from '../fn/storage-objects/upload-file';

@Injectable({ providedIn: 'root' })
export class StorageObjectsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listStorageObjects()` */
  static readonly ListStorageObjectsPath = '/v0/storageObjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listStorageObjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  listStorageObjects$Response(params?: ListStorageObjects$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDtoPage>> {
    return listStorageObjects(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listStorageObjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listStorageObjects(params?: ListStorageObjects$Params, context?: HttpContext): Observable<StorageObjectDtoPage> {
    return this.listStorageObjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<StorageObjectDtoPage>): StorageObjectDtoPage => r.body)
    );
  }

  /** Path part for operation `uploadFile()` */
  static readonly UploadFilePath = '/v0/storageObjects';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile$Response(params: UploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDto>> {
    return uploadFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadFile(params: UploadFile$Params, context?: HttpContext): Observable<StorageObjectDto> {
    return this.uploadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<StorageObjectDto>): StorageObjectDto => r.body)
    );
  }

  /** Path part for operation `getStorageObject()` */
  static readonly GetStorageObjectPath = '/v0/storageObjects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStorageObject()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStorageObject$Response(params: GetStorageObject$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDto>> {
    return getStorageObject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStorageObject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStorageObject(params: GetStorageObject$Params, context?: HttpContext): Observable<StorageObjectDto> {
    return this.getStorageObject$Response(params, context).pipe(
      map((r: StrictHttpResponse<StorageObjectDto>): StorageObjectDto => r.body)
    );
  }

  /** Path part for operation `updateStorageObject()` */
  static readonly UpdateStorageObjectPath = '/v0/storageObjects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStorageObject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStorageObject$Response(params: UpdateStorageObject$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDto>> {
    return updateStorageObject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateStorageObject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStorageObject(params: UpdateStorageObject$Params, context?: HttpContext): Observable<StorageObjectDto> {
    return this.updateStorageObject$Response(params, context).pipe(
      map((r: StrictHttpResponse<StorageObjectDto>): StorageObjectDto => r.body)
    );
  }

  /** Path part for operation `deleteStorageObject()` */
  static readonly DeleteStorageObjectPath = '/v0/storageObjects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteStorageObject()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStorageObject$Response(params: DeleteStorageObject$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteStorageObject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteStorageObject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteStorageObject(params: DeleteStorageObject$Params, context?: HttpContext): Observable<void> {
    return this.deleteStorageObject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `downloadFile()` */
  static readonly DownloadFilePath = '/v0/storageObjects/{id}/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadFile$Response(params: DownloadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    return downloadFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadFile(params: DownloadFile$Params, context?: HttpContext): Observable<any> {
    return this.downloadFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `getStorageObjectUrl()` */
  static readonly GetStorageObjectUrlPath = '/v0/storageObjects/{id}/url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStorageObjectUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStorageObjectUrl$Response(params: GetStorageObjectUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageUrlDto>> {
    return getStorageObjectUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStorageObjectUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStorageObjectUrl(params: GetStorageObjectUrl$Params, context?: HttpContext): Observable<StorageUrlDto> {
    return this.getStorageObjectUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<StorageUrlDto>): StorageUrlDto => r.body)
    );
  }

  /** Path part for operation `updateBulkStorageObject()` */
  static readonly UpdateBulkStorageObjectPath = '/v0/storageObjects/bulk/{assetId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBulkStorageObject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBulkStorageObject$Response(params: UpdateBulkStorageObject$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateBulkStorageObject(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBulkStorageObject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBulkStorageObject(params: UpdateBulkStorageObject$Params, context?: HttpContext): Observable<void> {
    return this.updateBulkStorageObject$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
